// src/serviceWorkerRegistration.js

// This function registers the service worker
// Optimized for performance - non-blocking registration
export function register() {
  if ("serviceWorker" in navigator && process.env.NODE_ENV === 'production') {
    // Use requestIdleCallback for non-blocking registration, fallback to setTimeout
    const registerSW = () => {
      const swUrl = "/firebase-messaging-sw.js";

      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          // Only log in development
          if (process.env.NODE_ENV === 'development') {
            console.log(
              "Service Worker registered with scope:",
              registration.scope
            );
          }
        })
        .catch((error) => {
          // Only log errors in development - don't block UI
          if (process.env.NODE_ENV === 'development') {
            console.error("Service Worker registration failed:", error);
          }
        });
    };

    // Register after page load to not block initial render
    if (window.requestIdleCallback) {
      window.requestIdleCallback(registerSW, { timeout: 2000 });
    } else {
      window.addEventListener("load", () => {
        setTimeout(registerSW, 0);
      });
    }
  } else if (process.env.NODE_ENV === 'development') {
    console.warn("Service Workers are not supported in this browser.");
  }
}

// This function unregisters the service worker
export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}
